export function languageLabel(languageKey) {
  return {
    'en_US': "English",
    'es_US': "Spanish"
  }[languageKey] || languageKey
}